<div style="display: inline-flex; flex-grow: 1; align-items: center; width: 100%;">
	<ng-container *ngIf="checkDisabledField(field)">
		<img alt="Insufficient Permissions"
			src="./assets/images/icons/red slash.png"
			title="You do not have permission to view"
			style="padding-bottom:3px;" />
		&nbsp;
	</ng-container>
	<ng-container *ngIf="!editable">
		{{field.DisplayName}}
		<span *ngIf="field.Alias != '' && field.Alias != null && field.Alias != field.DisplayName">
			&nbsp;[{{field.Alias}}]
		</span>		
	</ng-container>
	<ng-container *ngIf="editable">
		<tyl-form-field style="flex-grow: 1"
			[fullWidth]="true">
			<input matInput
				name="columnName"
				[id]="fieldId"
				[(ngModel)]="field.Alias">
		</tyl-form-field>
	</ng-container>
	<span *ngIf="(preferences && preferences.ShowObjectName) || ambiguous(field)"
		style="color: gray">
		<span *ngIf="V10">
			&nbsp;{{field.CategoryName}}
		</span>
		<span *ngIf="!V10">
			&nbsp;{{field.ObjectName}}
		</span>
	</span>	
	<div *ngIf="field.Editable == true && V10 == false && enableMassUpdate == true" style="width: 100%;">
			<img alt="Editable field" style="float: right; width: 14px;"
			src="./assets/images/edit.png"
			title="You do edit field" />
	</div>
</div>

